document.addEventListener('DOMContentLoaded', function() {
  const meetingMessage = document.querySelector('.js-meeting-message');
  if (meetingMessage) {
    document.dispatchEvent(new CustomEvent('sm-modal:open', {detail: {
      content: document.querySelector('.js-meeting-message').innerHTML
    }}));
  }
});
